import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {images} from './images'
import {selectedImages} from './selectedImages'
import {presetsReducer as presets} from './presets'
import {controlPanel} from './controlPanel'
import {openImage} from './openImage'
import {editHistory} from './editHistory'
import {editorCanvas} from './editorCanvas'
import {myImagesSettings} from './myImagesSettings'
import {auth} from './auth'
import {notification} from './notification';
import {usersReducer as users} from './users';
import {processingImages} from './processingImages';
import {imagesFetchStatus} from './imagesFetchStatus';
import {reducer as form} from 'redux-form'
import {registration} from './registeration';
import {captcha} from './captcha';
import {modals} from './modals';
import {demo} from './demo';

export const reducers = combineReducers({
    form,
    openImage,
    controlPanel,
    editHistory,
    editorCanvas,
    images,
    selectedImages,
    imagesFetchStatus,
    processingImages,
    users,
    registration,
    captcha,
    myImagesSettings,
    presets,
    auth,
    notification,
    modals,
    demo,
    router: routerReducer
});




// WEBPACK FOOTER //
// ./src/reducers/index.js